import { createResource, useResource } from '@atlassian/react-resource-router';
import { fetchAiEnablement } from './utils.tsx';
import type { AiEntitlementData } from './types.tsx';

const RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';

export const aiEntitlementResource = createResource<AiEntitlementData>({
	type: RESOURCE_TYPE_AI_ENTITLEMENT,
	getKey: () => RESOURCE_TYPE_AI_ENTITLEMENT,
	getData: () => fetchAiEnablement(),
	maxAge: 60 * 60 * 1000, // 1 hour
});

export const useAiEntitlementResource = () => useResource(aiEntitlementResource);
